import React from 'react';
import {
  type GDSHeadingLevel,
  type GDSHeadingSize,
  HeadingText,
  type GDSTypographyIntrinsicEmphasis,
} from '@leagueplatform/genesis-core';
import {
  type MasonryEngineNodeRendererProps,
  type MasonryEngineNode,
} from '@leagueplatform/masonry-engine';

type MasonryHeadingTextProperties = {
  heading: string;
  headingEmphasis?: GDSTypographyIntrinsicEmphasis;
  headingLevel?: GDSHeadingLevel;
  headingSize?: GDSHeadingSize;
};

export type MasonryHeadingTextNode = MasonryEngineNode<
  'headingText',
  MasonryHeadingTextProperties
>;

export type MasonryHeadingTextRendererProps =
  MasonryEngineNodeRendererProps<MasonryHeadingTextNode>;

export const MasonryHeadingTextRenderer = ({
  heading,
  headingEmphasis = 'base',
  headingLevel = '1',
  headingSize = 'xxl',
  className,
  locatorId,
  rootElementRef,
}: MasonryHeadingTextRendererProps) => (
  <HeadingText
    ref={rootElementRef}
    level={headingLevel}
    size={headingSize}
    emphasis={headingEmphasis}
    data-testid={locatorId}
    className={className}
  >
    {heading}
  </HeadingText>
);
